import types from "../actions/actionTypes";
import { createThunk } from "../../utilities/createThunk";
import backendAPI from "../../apis";
import { combineReducers } from "redux";

const initialState = {
  uploadFileContent: "",
  uploadFile: "",
  isUploadingFile: false,
};
export const fetchUploadFileContent = (values) => ({
  type: types.UPLOAD_FILE_CONTENT,
  payload: values,
});

export const resetUploadFileContent = (values) => ({
  type: types.RESET_UPLOAD_FILE_CONTENT,
  payload: values,
});

export const fetchUploadFile = createThunk({
  requestActionType: types.FETCH_UPLOAD_FILE_REQUEST,
  apiCall: backendAPI.uploadFileAPI.uploadFilePreSignedUrl,
});

const uploadFile = (state = initialState.uploadFile, { type, payload }) => {
  switch (type) {
    case types.FETCH_UPLOAD_FILE_REQUEST_SUCCESS:
      return payload;
    case types.RESET_FILE_UPLOAD_PAGE:
      return initialState.uploadFile;
    default:
      return state;
  }
};
const uploadFileData = (
  state = initialState.uploadFileContent,
  { type, payload }
) => {
  switch (type) {
    case types.UPLOAD_FILE_CONTENT:
      return payload;
    case types.RESET_UPLOAD_FILE_CONTENT:
      return payload;
    case types.RESET_FILE_UPLOAD_PAGE:
      return initialState.uploadFileContent;
    default:
      return state;
  }
};

const isUploadingFile = (
  state = initialState.isUploadingFile,
  { type, payload }
) => {
  switch (type) {
    case types.FETCH_UPLOAD_FILE_REQUEST:
      return true;
    case types.FETCH_UPLOAD_FILE_REQUEST_SUCCESS:
      return false;
    case types.FETCH_UPLOAD_FILE_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

export const UploadFileReducer = {
  uploadFileData,
};

export const resetFileUploadPage = () => ({
  type: types.RESET_FILE_UPLOAD_PAGE,
});

export default combineReducers({
  uploadFileData,
  uploadFile,
  isUploadingFile,
});
